__turbopack_context__.v({
  "image": "BlurImage-module__ebaEcW__image",
  "loaded": "BlurImage-module__ebaEcW__loaded",
  "wrapper": "BlurImage-module__ebaEcW__wrapper",
});
